import { ENDPOINTS } from '@/settings/endpoints';

const chatIframeName = 'Botmaker';
const openChatButton = 'wc-button-3';

export class SupportChatBot {
  static loadChatBot(): void {
    const regexp = /(?:^|;\s*)d-profile=([^;]*)/;
    const dProfileCookie = document.cookie.match(regexp);

    if (dProfileCookie && dProfileCookie[1]) {
      window.BOTMAKER_VAR = {
        cookie_accounts: decodeURIComponent(dProfileCookie[1]),
      };
    }

    const js = document.createElement('script');
    js.type = 'text/javascript';
    js.async = true;
    js.src = ENDPOINTS.botMakerUrl;
    document.body.appendChild(js);
  }

  static isChatLoaded(): boolean {
    return Boolean(document.getElementsByName(chatIframeName));
  }

  static hideChatBot(): void {
    document.getElementsByName(chatIframeName).forEach((e) => {
      e.style.display = 'none';
    });
  }

  static showChatBot(): void {
    document.getElementsByName(chatIframeName).forEach((e) => {
      e.style.display = 'flex';
    });
  }

  static openChatBot(): void {
    const botmaker: any = document.getElementsByName(chatIframeName)[0];
    const button = botmaker.contentWindow.document.body.getElementsByClassName(openChatButton)[0];

    button.click();
  }
}
